import { render, staticRenderFns } from "./MyLoans.vue?vue&type=template&id=7bb71a71"
import script from "./MyLoans.vue?vue&type=script&lang=js"
export * from "./MyLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports